import { IssuesGrid } from '@rdrive/plugin-items-grid';
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import { BaseTimeSeriesChart } from '@rdrive/plugin-chart-time-series';
import { TotalAndAssignedCards, StatusBreakdownCard } from '@rdrive/plugin-total-cards';
import setup from './setup.js';

export default {
  name: 'project-page',
  components: { IssuesGrid, StackedHorizontalBarChart, BaseTimeSeriesChart, TotalAndAssignedCards, StatusBreakdownCard },
  setup,
};
